const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
})

const integer = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

const shortDate = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
})

export const formatPrice = (value: number): string => currency.format(value)

export const formatCompactPrice = (value: number): string => {
    if (value >= 1_000_000) {
        const millions = value / 1_000_000
        const digits = millions >= 10 ? 1 : 2

        return `$${Number(millions.toFixed(digits))}M`
    }

    if (value >= 1_000) return `$${Math.round(value / 1_000)}K`

    return `$${value}`
}

export const formatNumber = (value: number): string => integer.format(value)

export const formatBaths = (value: number): string => Number.isInteger(value) ? String(value) : value.toFixed(1)

export const formatLot = (sqft: number): string => {
    if (sqft >= 21_780) {
        const acres = sqft / 43_560

        return `${Number(acres.toFixed(acres >= 10 ? 0 : 2))} acre${acres === 1 ? '' : 's'} lot`
    }

    return `${integer.format(sqft)} sq ft lot`
}

export const formatDate = (value: string | null): string => {
    if (!value) return ''

    const time = Date.parse(value)

    return Number.isNaN(time) ? '' : shortDate.format(new Date(time))
}

export const plural = (count: number, word: string, pluralWord = `${word}s`): string => `${count === 1 ? word : pluralWord}`
